import layout from '../layout/layout';
import SessionsView from '../Component/Sessions/SessionsView';

const Sessions = () => <SessionsView />;
export default layout(Sessions);


